import { render, staticRenderFns } from "./dataSummary.vue?vue&type=template&id=415b80ef&"
import script from "./dataSummary.vue?vue&type=script&lang=js&"
export * from "./dataSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('415b80ef')) {
      api.createRecord('415b80ef', component.options)
    } else {
      api.reload('415b80ef', component.options)
    }
    module.hot.accept("./dataSummary.vue?vue&type=template&id=415b80ef&", function () {
      api.rerender('415b80ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/dataSummary.vue"
export default component.exports